// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Overlay con el logo parpadeando entre pantallas.
   El fondo sigue al tema activo: con #fff fijo, cada navegacion provocaba
   un destello blanco a pantalla completa estando en tema oscuro. */
.pt-overlay {
  position: fixed;
  inset: 0;
  background: var(--sn-fondo);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: opacity 0.25s ease, visibility 0.25s;
}

.pt-overlay--show {
  opacity: 1;
  visibility: visible;
  pointer-events: all;
}

.pt-logo {
  width: 150px;
  height: auto;
  animation: ptBlink 0.9s ease-in-out infinite;
}

@keyframes ptBlink {
  0%, 100% { opacity: 1; }
  50%       { opacity: 0.15; }
}
`, "",{"version":3,"sources":["webpack://./src/components/PageTransition.css"],"names":[],"mappings":"AAAA;;mEAEmE;AACnE;EACE,eAAe;EACf,QAAQ;EACR,2BAA2B;EAC3B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,kBAAkB;EAClB,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,4CAA4C;AAC9C;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,YAAY,aAAa,EAAE;AAC7B","sourcesContent":["/* Overlay con el logo parpadeando entre pantallas.\n   El fondo sigue al tema activo: con #fff fijo, cada navegacion provocaba\n   un destello blanco a pantalla completa estando en tema oscuro. */\n.pt-overlay {\n  position: fixed;\n  inset: 0;\n  background: var(--sn-fondo);\n  z-index: 9999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 0;\n  visibility: hidden;\n  pointer-events: none;\n  transition: opacity 0.25s ease, visibility 0.25s;\n}\n\n.pt-overlay--show {\n  opacity: 1;\n  visibility: visible;\n  pointer-events: all;\n}\n\n.pt-logo {\n  width: 150px;\n  height: auto;\n  animation: ptBlink 0.9s ease-in-out infinite;\n}\n\n@keyframes ptBlink {\n  0%, 100% { opacity: 1; }\n  50%       { opacity: 0.15; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
